<template>
  <div class="table-responsive">
    <table class="table table-striped table-vcenter">
      <thead>
        <tr>
          <th>姓名</th>
          <th class="text-center">电话</th>
          <th class="text-center">区域</th>
          <th class="text-center">人员层级</th>
          <th class="text-center">上级</th>
          <th class="text-center">下属</th>
          <th class="text-center">日报数量</th>
          <th class="text-center">当前项目</th>
          <th class="text-center">状态</th>
          <th class="text-center">创建时间</th>
          <th class="text-center">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in list" :key="user.id">
          <td>
            <template v-if="user.status == 0 && user.remark">
              <a
                class="add-tooltip"
                data-toggle="tooltip"
                href="javascript:;"
                :data-original-title="user.remark"
                >{{ user.name
                }}<i
                  class="ion-help-circled text-info"
                  style="position: relative; top: -5px; font-size: 12px"
                ></i
              ></a>
            </template>
            <template v-else>
              {{ user.name }}
            </template>
          </td>
          <td class="text-center">{{ user.phone_number }}</td>
          <td class="text-center">
            <template v-if="user.region_names">
              <div v-for="region in user.region_names" :key="region">
                {{ region }}
              </div>
            </template>
            <div v-else>无</div>
          </td>
          <td class="text-center">{{ ReportUserLevelMap[user.level] }}</td>
          <td class="text-center">{{ user.father.name || '无' }}</td>
          <td class="text-center">
            <template v-if="user.subordinate_names">
              <div v-for="name in user.subordinate_names" :key="name">
                {{ name }}
              </div>
            </template>
            <div v-else>无</div>
          </td>
          <td class="text-center">
            <router-link
              :to="`/report/reports?user_id=${user.id}`"
              class="text-primary"
              >{{ user.report_count }}</router-link
            >
          </td>
          <td class="text-center">
            <div v-for="item in user.project_users" :key="item.id">
              {{ item.project.pit_number }}
            </div>
          </td>
          <td class="text-center">{{ user.status == 1 ? '启用' : '禁用' }}</td>
          <td class="text-center">
            {{ $time(user.created_at).format('YYYY-MM-DD HH:mm') }}
          </td>
          <td class="text-center">
            <el-button
              v-code="26101"
              type="text"
              size="mini"
              @click="$router.push(`/report/users/${user.id}/edit`)"
              >编辑</el-button
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { ReportUserLevelMap } from '../../../config/global'
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ReportUserLevelMap,
    }
  },
}
</script>